import { EProblemReportStatus } from '@constants';
import { Checkbox, Select } from 'antd';
import { useTranslation } from 'react-i18next';

import {
  CounterWrapper,
  DropdownWrapper,
  LabelWrapper,
  OptionsWrapper,
  Wrapper
} from './ReportStatusFilter.styles';

import { Icon } from '@/components/Icon';

type ReportStatusValue = EProblemReportStatus.NOT_REVIEWED | EProblemReportStatus.IN_REVIEW;

type Props = {
  value?: ReportStatusValue[];
  onChange?: (value?: ReportStatusValue[]) => void;
  disabled?: boolean;
};

const REPORT_STATUS_OPTIONS: ReportStatusValue[] = [
  EProblemReportStatus.NOT_REVIEWED,
  EProblemReportStatus.IN_REVIEW
];

export const ReportStatusFilter: React.FC<Props> = ({ value = [], onChange, disabled = false }) => {
  const { t } = useTranslation('ProblemReportsTranslations');

  const handleToggle = (status: ReportStatusValue) => {
    if (value.includes(status)) {
      const newValue = value.filter(v => v !== status);
      onChange?.(newValue.length > 0 ? newValue : undefined);
    } else {
      onChange?.([...value, status]);
    }
  };

  return (
    <Wrapper $hasValue={value.length > 0}>
      <Select
        variant="borderless"
        value={value}
        styles={{ popup: { root: { minWidth: 160 } } }}
        labelRender={() => (
          <LabelWrapper>
            <span>{t('REPORT_STATUS')}</span>
            {value.length > 0 && (
              <CounterWrapper $isDisabled={disabled}>{value.length}</CounterWrapper>
            )}
          </LabelWrapper>
        )}
        suffixIcon={<Icon i="CaretDown" />}
        placeholder={t('REPORT_STATUS')}
        disabled={disabled}
        dropdownRender={() => (
          <DropdownWrapper onClick={e => e.stopPropagation()}>
            <OptionsWrapper>
              {REPORT_STATUS_OPTIONS.map(status => (
                <div key={status} className="option" onClick={() => handleToggle(status)}>
                  <Checkbox checked={value.includes(status)} />
                  <span>{t(`REPORT_STATUS_${status}`)}</span>
                </div>
              ))}
            </OptionsWrapper>
          </DropdownWrapper>
        )}
      />
    </Wrapper>
  );
};
